import { ChangeDetectionStrategy, Component, computed, input, output, TemplateRef } from '@angular/core';
import { ServiceStateEnum } from '@mwe/constants';
import { AlertType, InlineNotificationType } from '@mwe/models';
import { NgTemplateOutlet } from '@angular/common';
import { BasicCardComponent } from '../cards/basic-card/basic-card.component';
import { LoadingSpinnerComponent } from '../loading-module/loading/loading-spinner.component';
import { LoadingSpinnerExtendedComponent } from '../loading-module/loading/loading-spinner-extended.component';
import { LoadingSpinnerExtendedWhiteBackgroundComponent } from '../loading-module/loading/loading-spinner-extended-white-background.component';
import { InlineNotificationComponent } from '../inline-notification/inline-notification.component';
import { SpecialAlertComponent } from '../alert/special-alert.component';
import { EmptyStateComponent } from '../empty-state/empty-state.component';

@Component({
  selector: 'mwe-pre-load-data',
  templateUrl: './pre-load-data.component.html',
  imports: [
    NgTemplateOutlet,
    BasicCardComponent,
    LoadingSpinnerComponent,
    LoadingSpinnerExtendedComponent,
    LoadingSpinnerExtendedWhiteBackgroundComponent,
    InlineNotificationComponent,
    SpecialAlertComponent,
    EmptyStateComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PreLoadDataComponent {
  readonly state = input<ServiceStateEnum>();
  readonly alertTitleKey = input<string>('newClient.status.loadError.key');
  readonly alertMessageKey = input<string>('newClient.status.loadError.text');
  readonly alertType = input<AlertType>('danger');
  readonly inlineNotificationType = input<InlineNotificationType>(null); // will replace alertType
  readonly errorPlaceholderMap = input<Map<string, string>>();
  readonly successTemplate = input.required<TemplateRef<any>>();
  readonly errorTemplate = input<TemplateRef<any>>();
  readonly loadingTemplate = input<TemplateRef<any>>();
  readonly specialAlertError = input<boolean>(false);
  readonly loadingSpinnerType = input<'normal' | 'normal-without-box' | 'extended' | 'extended-white-background'>('normal');
  readonly reloadButtonKey = input<string>();
  readonly errorType = input<'noData' | 'error'>(undefined); // Unified error display.

  readonly reloadButtonClicked = output<void>();

  readonly loadingState = computed<boolean>(() => this.state() === ServiceStateEnum.LOADING);
  readonly errorState = computed<boolean>(() => this.state() === ServiceStateEnum.ERROR);
  readonly successState = computed<boolean>(() => this.state() === ServiceStateEnum.SUCCESS);
}
